import React, { forwardRef } from 'react';
import NumberFormat from 'react-number-format';

const NumberFormatInput = (props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      allowedDecimalSeparators={['.']}
      decimalScale={2}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
};

export default forwardRef(NumberFormatInput);
